import { consoleErrorUnlessFiltered } from '../../../util/sentryFilters';

/**
 * Render-time product-list preparation. Always reaches ProductStore.loadProducts
 * so orphaned LOADING from snapshots can recover; the store owns cache, live
 * requests, and terminal ERROR gating.
 *
 * @param {Object} props
 * @param {ProductStore} props.productStore
 * @param {Object} props.params
 * @param {Object} props.params.searchParams
 * @param {Boolean} props.params.allSections
 */
const useFetchData = ({ productStore, params }) => {
  productStore
    .loadProducts(params.searchParams, params.allSections)
    .catch((e) => {
      consoleErrorUnlessFiltered(e);
    });
};

export default useFetchData;
